import { useEffect, useState } from "react";
import Button from "../../components/Button";
import FormInput from "../../components/FormInput";
import Spacer from "../../components/Spacer";
import { apiUrl, executeRequest, getToken } from "../../functions/requests";
import IconCheck from "../../icons/IconCheck";

export default function UserEdit({ userData, user, onCancelled, onEditted }) {
  const [loading, setLoading] = useState(true);
  const [userRoles, setUserRoles] = useState(null);
  const [userToEditData, setUserToEditData] = useState(user);

  // Get available roles
  const getUserRoles = async () => {
    setLoading(true);
    await executeRequest(
      apiUrl + "users/roles",
      "GET",
      null,
      {
        Authorization: "Bearer " + getToken(),
      },
      async (data) => {
        setUserRoles(data);
      },
      (error) => {
        console.log(error);
      }
    );
    setLoading(false);
  };

  // Create user
  const updateUser = async () => {
    if (userData == null) return;
    setLoading(true);
    const finalFields = new FormData();
    for (let key in userToEditData) {
      if (userToEditData.hasOwnProperty(key)) {
        // Check if the field has changed
        if (userToEditData[key] !== user[key]) {
          // If the value is a File (e.g., image or other binary data)
          if (userToEditData[key] instanceof File) {
            finalFields.append(key, userToEditData[key]);
          } else {
            // Append other data as strings
            finalFields.append(key, userToEditData[key]);
          }
        }
      }
    }

    // Log each field in the FormData
    for (let [key, value] of finalFields.entries()) {
      console.log(`${key}:`, value);
    }

    // Conditional URL depending on user type
    let url =
      userData.user_type !== "user"
        ? apiUrl + "customer-users/" + userToEditData.uuid
        : apiUrl + "users/" + userToEditData.uuid;

    await executeRequest(
      url,
      "POST",
      finalFields,
      {
        Authorization: "Bearer " + getToken(),
      },
      (data) => {
        onEditted(data);
      },
      (error) => {
        console.log(error);
      }
    );
    setLoading(false);
  };

  useEffect(() => {
    getUserRoles();
  }, []);

  return (
    <div>
      <h1 className="page-title">Update user</h1>
      <Button
        text="< Back to users"
        type="underlined"
        onClicked={() => {
          if (loading) return;
          onCancelled();
        }}
      />
      <Spacer />
      <FormInput
        type="text"
        title="First name"
        value={userToEditData.first_name}
        onChanged={(value) =>
          setUserToEditData({
            ...userToEditData,
            first_name: value,
          })
        }
      />
      <Spacer />
      <FormInput
        type="text"
        title="Last name"
        value={userToEditData.last_name}
        onChanged={(value) =>
          setUserToEditData({
            ...userToEditData,
            last_name: value,
          })
        }
      />
      <Spacer />
      <FormInput
        type="email"
        title="Email"
        value={userToEditData.email}
        onChanged={(value) =>
          setUserToEditData({
            ...userToEditData,
            email: value,
          })
        }
      />
      <Spacer />
      <FormInput
        type="text"
        title="Phone"
        value={userToEditData.phone}
        onChanged={(value) =>
          setUserToEditData({
            ...userToEditData,
            phone: value,
          })
        }
      />
      <Spacer />
      <FormInput
        type="text"
        title="Password"
        value={userToEditData.password}
        onChanged={(value) =>
          setUserToEditData({
            ...userToEditData,
            password: value,
          })
        }
      />
      <Spacer />
      {userRoles !== null && (
        <>
          <FormInput
            type="select"
            title="Role"
            value={userToEditData.role.uuid}
            selectOptions={userRoles}
            selectAllowEmptyOption={false}
            onChanged={(value) =>
              setUserToEditData({
                ...userToEditData,
                role: value,
              })
            }
          />
          <Spacer />
        </>
      )}
      <Button
        icon={<IconCheck />}
        text="Update"
        loading={loading}
        onClicked={() => updateUser()}
      />
    </div>
  );
}
